import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ResponsiveSummaryWrapper = ({ matches, handleOnClick, expanded, children }) => {
	const { t } = useTranslation(['candidate-feedback']);
	const { collapsedLabel, expandedLabel } = React.useMemo(
		() => ({
			collapsedLabel: t('meta_data_accordion_collapse'),
			expandedLabel: t('meta_data_accordion_expand'),
		}),
		[t],
	);

	if (matches) {
		return (
			<Box
				data-testid="feedback-info"
				sx={{
					paddingX: 1,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
				}}
			>
				{children}
			</Box>
		);
	}
	return (
		<Box
			data-testid="feedback-info"
			id="feedback-info"
			sx={{
				cursor: 'pointer',
				padding: 1,
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
			}}
		>
			{children}
			<IconButton
				id="feedback-info-button"
				data-testid="feedback-info-button"
				onClick={handleOnClick}
				aria-label={expanded ? collapsedLabel : expandedLabel}
				aria-controls={'collapsable-content'}
				aria-expanded={expanded}
			>
				{expanded ? (
					<ArrowUp sx={{ color: 'text.primary' }} />
				) : (
					<ArrowDown sx={{ color: 'text.primary' }} />
				)}
			</IconButton>
		</Box>
	);
};

export default ResponsiveSummaryWrapper;
